/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:57.875
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listEvaluationMicroRemakeProblem,
	listEvaluationMicroRemakeProblemInit,
	listEvaluationMicroRemakeProblemByAuthorizations,
	deleteEvaluationMicroRemakeProblem
} from '@api/lcf/EvaluationMicroRemakeProblem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listEvaluationMicroRemakeProblem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEvaluationMicroRemakeProblem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listEvaluationMicroRemakeProblemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEvaluationMicroRemakeProblemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listEvaluationMicroRemakeProblemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEvaluationMicroRemakeProblemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteEvaluationMicroRemakeProblem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteEvaluationMicroRemakeProblem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
